import axios from 'axios';
import { encerrarSessao } from './sessao';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3001',
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// O backend responde 401 com code SESSAO_* quando o token venceu ou não vale mais.
// Senha errada no login também é 401, mas sem code, e segue para o formulário.
const MOTIVO_POR_CODIGO = {
  SESSAO_EXPIRADA: 'expirada',
  SESSAO_INVALIDA: 'invalida',
  SESSAO_AUSENTE: 'invalida',
};

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const motivo = error.response?.status === 401 && MOTIVO_POR_CODIGO[error.response.data?.code];

    if (motivo && encerrarSessao(motivo)) {
      // A página vai recarregar no login: segura a promessa para a tela não
      // mostrar um toast de erro sem sentido antes disso.
      return new Promise(() => {});
    }

    return Promise.reject(error);
  }
);

export default api;
